/**
 * @file The action base
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { AbstractBase } from '../helpers/abstract-base';
var ActionBase = /** @class */ (function (_super) {
    tslib_1.__extends(ActionBase, _super);
    /**
     * Creates an instance of ActionBase.
     * @param {string} icon
     * @param {string} labelKey
     */
    function ActionBase(icon, labelKey) {
        var _this = _super.call(this) || this;
        _this.icon = icon;
        _this.labelKey = labelKey;
        return _this;
    }
    /**
    * Execute the action
    * @param {ActionConfiguration} actionConfiguration The action configuration
    * @returns {Promise<string>} The success message
    */
    ActionBase.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, Promise.reject({ labelKey: 'APP.SOCIAL.ACTION_NOT_FOUND', message: 'Action is not implemented' })];
            });
        });
    };
    /**
     * Save the items
     * @param {BreezeService} breezeService
     */
    ActionBase.prototype.save = function (breezeService) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.subscriptionPool.add(breezeService.saveChanges(function (error) {
                            if (error) {
                                var entityErrors = error.entityErrors;
                                if (entityErrors) {
                                    entityErrors.forEach(function (entityError) {
                                        breezeService.rejectChanges();
                                        reject({ labelKey: entityError.errorName, message: new Error(entityError.errorMessage) });
                                    });
                                }
                                var detailedMessage = error.error ? error.error.message : error.message;
                                breezeService.rejectChanges();
                                reject({ labelKey: 'APP.LISTS.ITEMS_UNSUCCESSFULLY_SAVED', message: detailedMessage });
                            }
                        }).subscribe(function (response) {
                            resolve();
                        }));
                    })];
            });
        });
    };
    ActionBase.prototype.isAllowed = function (entity, name) {
        return true;
    };
    ActionBase.prototype.isDisabled = function (entity, name, backendSettingsService, userService) {
        var isOnTime = backendSettingsService.isOnTime(entity);
        return !isOnTime || entity['Closed'] || (entity['Item'] != null && entity['Item']['Closed']);
    };
    ActionBase.prototype.getIcon = function () {
        return this.icon;
    };
    ActionBase.prototype.getLabelKey = function () {
        return this.labelKey;
    };
    return ActionBase;
}(AbstractBase));
export { ActionBase };
